import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

const ScreeningSection = ({
  title,
  type,
  items,
  values,
  onChange,
  disabled,
  activeNames,
  forcedDisabledNames,
  className,
}) => {
  const isItemDisabled = (item) => {
    if (forcedDisabledNames.includes(item.name)) return true;
    if (!disabled) return false;

    // If a specific active list is provided, only items NOT in it get disabled.
    // If no active list is provided, disabled applies to every item in the section.
    if (activeNames.length > 0) {
      return !activeNames.includes(item.name);
    }
    return true;
  };

  return (
    <div className={`screening-section ${className || ""}`}>
      {title && <div className="screening-section-title">{title}</div>}
      <div className="screening-section-body">
        {items?.map((item, index) => {
          const itemDisabled = isItemDisabled(item);

          if (type === "radio") {
            const options = item.options || [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ];
            return (
              <div
                key={item.name}
                className={`screening-question d-flex justify-content-between align-items-start ${
                  itemDisabled ? "screening-item-disabled" : ""
                }`}
              >
                <span className="screening-question-label">
                  <span className="screening-question-number">
                    {index + 1}.
                  </span>
                  <span className="screening-question-text">
                    {item.label}
                    {item.required && <span className="required">*</span>}
                  </span>
                </span>
                <div className="d-flex gap-3 screening-radio-group flex-shrink-0">
                  {options.map((option) => (
                    <Form.Check
                      key={option.label}
                      inline
                      type="radio"
                      id={`${item.name}-${option.label}`}
                      name={item.name}
                      label={option.label}
                      checked={values?.[item.name] === option.value}
                      disabled={itemDisabled}
                      onChange={() => onChange(item.name, option.value)}
                    />
                  ))}
                </div>
              </div>
            );
          }

          return (
            <div
              key={item.name}
              className={`screening-checkbox-item ${itemDisabled ? "screening-item-disabled" : ""}`}
            >
              <Form.Check
                type="checkbox"
                id={item.name}
                name={item.name}
                label={item.label}
                checked={!!values?.[item.name]}
                disabled={itemDisabled}
                onChange={(e) => onChange(item.name, e.target.checked)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

ScreeningSection.propTypes = {
  title: PropTypes.node,
  type: PropTypes.oneOf(["radio", "checkbox"]).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      options: PropTypes.arrayOf(PropTypes.object),
      required: PropTypes.bool,
    }),
  ).isRequired,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  activeCount: PropTypes.number,
  forcedDisabledNames: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

ScreeningSection.defaultProps = {
  values: {},
  disabled: false,
  activeNames: [],
  forcedDisabledNames: [],
  className: "",
};

export default ScreeningSection;
